import React from "react";
import "./SslProtectionSection.css";

function SslProtectionSection() {
  const sslPoints = [
    "Protect website traffic with HTTPS encryption",
    "Increase customer trust with secure browsing",
    "Help prevent data interception and misuse",
    "Support safer login and form submissions",
    "Improve overall website credibility",
    "Secure business and user interactions",
  ];

  return (
    <section className="sps-section">
      <div className="sps-container">
        <div className="sps-layout">
          <div className="sps-left">
            <span className="sps-badge">SSL Security</span>

            <h2>Trusted SSL and Security Protection for Your Website</h2>

            <p>
              Keep your site secure with SSL certificates, domain safety, and
              stronger account protection workflows.
            </p>

            <div className="sps-actions">
              <a href="#security-ssl-form" className="sps-btn sps-btn-primary">
                Request SSL
              </a>

              <a href="#security-main-form" className="sps-btn sps-btn-secondary">
                General Enquiry
              </a>
            </div>
          </div>

          <div className="sps-right">
            <div className="sps-box">
              <div className="sps-box-header">
                <div className="sps-lock-icon">🔐</div>
                <div>
                  <h3>Website Protection Checklist</h3>
                  <p>Essential security layers for trusted browsing.</p>
                </div>
              </div>

              {sslPoints.map((item, index) => (
                <div className="sps-item" key={index}>
                  <span className="sps-check">✓</span>
                  <p>{item}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SslProtectionSection;